import { connect } from 'react-redux';
import {
  fetchSampleGroups, fetchWritingSamples, fetchImageSamples, fetchIdPhotoIfNeeded
} from 'registration/creative/ducks';
import { setBannerError } from 'error';
import WorkSamples from 'account/components/id_verification/work_samples';

const mapStateToProps = ({ user, creativeRegistration }) => {
  const {
    sampleGroups, workSamples, workSamplesMeta, idValidated, idVerificationStatus
  } = creativeRegistration;

  return {
    user: user.profile_data,
    groups: sampleGroups,
    samples: workSamples,
    samplesMeta: workSamplesMeta,
    idVerificationStatus,
    idValidated
  };
}

export default connect(mapStateToProps, {
  fetchSampleGroups,
  fetchWritingSamples,
  fetchImageSamples,
  fetchIdPhotoIfNeeded,
  setBannerError
})(WorkSamples);



// WEBPACK FOOTER //
// ./account/containers/id_verification/work_samples.js